import { useEffect } from 'react';

import Table from '../../../components/table/table';

export default function QuestionTypeTable({ question, params, onChange, addError, showErrors, error, sectionId, blockId, getQuestionValue }) {
    const onComponentChange = (e) => {
        onChange(e, blockId, question.id);
        setError(e);
    }

    const setError = (e = null) => {
        let event = e !== null ? e : params;
        let fail  = false;
        let failCount = 0;
        const minRequiredRows = parseInt(question.min_rows_required);


        if (question.response_required) {

            if(Array.isArray(event.value) === false) {
                event.value = [];
                fail = true;
            }


            event.value.forEach(r => {

                if(Object.keys(r).length < question.columns.length) {

                    if(fail === true) {
                        failCount ++;
                        return;
                    }
                    failCount ++;
                    fail = true;
                }
            });
            let errors = ['Table fields cannot be empty'];

            if(minRequiredRows >= 1) {
                if(event.value < minRequiredRows) {
                    fail = true;
                    errors.push('Minimum required completed rows: ' + minRequiredRows);
                }
            }

            if(failCount > minRequiredRows) {
                fail = true;
            }


            addError(fail, errors, sectionId, question.id, question);

        }
    }

    useEffect(() => {
        setError();
    }, [])

    const newParams = {

    }

    params = Object.assign({}, newParams, params);

    return (
        <div className="section-content__container">
            { params.label && <p className="section-content__label">{ params.label }</p> }
            { params.description && <p className="section-content__description" dangerouslySetInnerHTML={{ __html: params.description }}></p> }

            <Table columns={question.columns}
                    allowNewRows={question.allow_new_rows}
                    defaultRowCount={question.default_row_count}
                    maxRowCount={question.max_row_count}
                    onChange={onComponentChange}
                    { ...params } />

            { showErrors && error.length > 0 &&
                <div className="section-content__errors">
                    { error.map(err => <p className="section-content__error">{ err }</p>)}
                </div>
            }
        </div>
    )
}
